import { atomEffect as baseAtomEffect } from '@exodus/jotai/effect';
import { exodusAtom, selectorsAtomsAtoms } from '../core/atoms.js';
export const atomEffect = (effect) => {
    return baseAtomEffect((get, set) => {
        const exodus = get(exodusAtom);
        const selectors = get(selectorsAtomsAtoms);
        effect(get, set, { exodus, selectors });
    });
};
